const Input = {
  baseStyle: {
    field: {
      _placeholder: {
        opacity: 0.8, 
        color: '#333'
      },
    }
  },
  variants: {
    filled: (props) => ({
      _placeholder: {
        opacity: 0.8, 
        color: '#333'
      },
    }),
  }
}

export default Input;